import { alpha, Box, Typography, useTheme } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

export default function AtendimentoTabSkeleton() {
  const theme = useTheme();
  return (
    <Box display="flex" flexDirection="column" height="100%" gridGap={4}>
      <Box display="flex" flexDirection="column" gridGap={4}>
        {Array.from(new Array(5)).map((_, i) => (
          <Box
            key={`infos-${i + 1}`}
            display="flex"
            alignItems="center"
            gridGap={8}
          >
            <Skeleton width="100%" height={21} />
          </Box>
        ))}
      </Box>

      <Typography
        variant="body2"
        style={{
          fontWeight: theme.typography.fontWeightBold as number,
          color: alpha(theme.palette.primary.main, 0.7),
          marginBlock: theme.spacing(3),
        }}
      >
        Comentários do atendimento
      </Typography>

      <Box flex="1" display="flex" flexDirection="column" gridGap={8}>
        {Array.from(new Array(4)).map((_, i) => (
          <Skeleton
            key={`comments-${i + 1}`}
            variant="rect"
            height={100}
            style={{ borderRadius: 8 }}
          />
        ))}
      </Box>

      <Box display="flex" alignItems="center" gridGap={12}>
        <Skeleton variant="circle" width={36} height={36} />

        <Skeleton
          variant="rect"
          height={42}
          style={{
            flex: 1,
            borderRadius: 24,
          }}
        />

        <Skeleton variant="circle" width={28} height={28} />
      </Box>
    </Box>
  );
}
